var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "modal-body" }, [
      _c(
        "form",
        {
          staticClass: "m-form m-form--state",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submitForm.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "m-portlet__body" }, [
            _c("div", { staticClass: "form-group m-form__group row" }, [
              _c("div", { staticClass: "col-lg-6" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm._f("capitalize")("entrance_name")))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.log.device,
                      expression: "log.device"
                    }
                  ],
                  staticClass: "form-control m-input",
                  attrs: {
                    type: "text",
                    id: "entrance_name_req",
                    readonly: "",
                    name: "entrance_name_req"
                  },
                  domProps: { value: _vm.log.device },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.log, "device", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm._f("capitalize")("reference_one")))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.log.device_reference,
                      expression: "log.device_reference"
                    }
                  ],
                  staticClass: "form-control m-input",
                  attrs: {
                    type: "text",
                    id: "reference_one_req",
                    readonly: "",
                    name: "reference_one_req"
                  },
                  domProps: { value: _vm.log.device_reference },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.log, "device_reference", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm._f("capitalize")("url_request")))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.log.url,
                      expression: "log.url"
                    }
                  ],
                  staticClass: "form-control m-input",
                  attrs: { type: "text", id: "url", readonly: "", name: "url" },
                  domProps: { value: _vm.log.url },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.log, "url", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm._f("capitalize")("request_made_by")))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.log.remote_ip,
                      expression: "log.remote_ip"
                    }
                  ],
                  staticClass: "form-control m-input",
                  attrs: {
                    type: "text",
                    id: "remote_ip",
                    readonly: "",
                    name: "remote_ip"
                  },
                  domProps: { value: _vm.log.remote_ip },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.log, "remote_ip", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group m-form__group row" }, [
              _c("div", { staticClass: "col-lg-6" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm._f("capitalize")("request_made_from")))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.log.remote_location,
                      expression: "log.remote_location"
                    }
                  ],
                  staticClass: "form-control m-input",
                  attrs: {
                    type: "text",
                    id: "remote_location",
                    readonly: "",
                    name: "remote_location"
                  },
                  domProps: { value: _vm.log.remote_location },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.log, "remote_location", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6" }, [
                _c("label", [_vm._v(_vm._s(_vm._f("capitalize")("user")))]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.log.user,
                      expression: "log.user"
                    }
                  ],
                  staticClass: "form-control m-input",
                  attrs: {
                    type: "text",
                    id: "user_req",
                    readonly: "",
                    name: "user_req"
                  },
                  domProps: { value: _vm.log.user },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.log, "user", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group m-form__group row" }, [
              _c("div", { staticClass: "col-lg-6" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm._f("capitalize")("request_status")))
                ]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.log.request_result,
                      expression: "log.request_result"
                    }
                  ],
                  staticClass: "form-control form-control-danger m-input",
                  attrs: { readonly: "", name: "request_result", rows: "4" },
                  domProps: { value: _vm.log.request_result },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.log, "request_result", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm._f("capitalize")("request_made_at")))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.log.created_at,
                      expression: "log.created_at"
                    }
                  ],
                  staticClass: "form-control m-input",
                  attrs: {
                    type: "text",
                    id: "created_at_req",
                    readonly: "",
                    name: "created_at_req"
                  },
                  domProps: { value: _vm.log.created_at },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.log, "created_at", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group m-form__group row" }, [
              _c("div", { staticClass: "col-lg-12" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm._f("capitalize")("implicated_data")))
                ]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.log.implicated_data,
                      expression: "log.implicated_data"
                    }
                  ],
                  staticClass: "form-control form-control-danger m-input",
                  attrs: { readonly: "", name: "data", rows: "3" },
                  domProps: { value: _vm.log.implicated_data },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.log, "implicated_data", $event.target.value)
                    }
                  }
                })
              ])
            ])
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button", "data-dismiss": "modal", id: "btn-cancel" },
          on: {
            click: function($event) {
              return _vm.setStatusLogModal(false)
            }
          }
        },
        [_vm._v("\n      " + _vm._s(_vm._f("capitalize")("close")) + "\n    ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2eb6c4d0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eb6c4d0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/logs/Base_req.vue
// module id = 580
// module chunks = 0 1 17 182